import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  formWrapper: {
    padding: theme.spacing(8, 0, 4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(6, 0, 2),
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '16px',
    textAlign: 'start',
    lineHeight: '19px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    paddingRight: theme.spacing(3),
  },
  formTitle: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '20px',
    textAlign: 'start',
    lineHeight: '23px',
    color: theme.custom.blackColor,
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '20px',
    },
  },
  checkboxContainer: {
    width: '100%',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: '-10px',
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
    },
  },
  checkBoxDesc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    textAlign: 'start',
    lineHeight: '23px',
    color: theme.custom.blackColor,
    opacity: '.8',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  subHeading: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    textAlign: 'start',
    lineHeight: '23px',
    color: theme.custom.blackColor,
    padding: theme.spacing(5, 0, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },

  confirmBox: {
    background: 'rgba(197, 206, 214, 0.15)',
    borderRadius: '16px',
    padding: theme.spacing(4.5, 5),
    margin: theme.spacing(5, 0),
  },
  recommendBtn: {
    width: '100%',
    background: 'black',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
  wrapperClass: {
    width: '100%',
    margin: theme.spacing(8, 0, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(6, 0, 0),
    },
  },
}))

export default useStyles
